var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3337 13.6663V13.4575C15.3337 12.5138 15.9 11.6787 16.7762 11.3287C17.0512 11.22 17.3363 11.165 17.625 11.165C18.2513 11.165 18.8575 11.4263 19.2887 11.8813L20.0263 12.6587C20.2175 12.3437 20.3337 11.9775 20.3337 11.5825V4.0825C20.3337 2.9325 19.4013 2 18.25 2H4.08375C2.9325 2 2 2.9325 2 4.08375V11.5837C2 12.7337 2.9325 13.6675 4.08375 13.6675H10.9587H15.3337V13.6663ZM3.66625 5.44125V4.05875L11.1662 7.55875L18.6662 4.05875V5.4425L11.6075 8.73375C11.4662 8.8 11.3162 8.83375 11.1662 8.83375C11.0162 8.83375 10.8663 8.8 10.725 8.73375L3.66625 5.44125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8287 16.9875L18.0787 13.0287C17.9025 12.8425 17.6325 12.7837 17.3937 12.8775C17.1562 12.9725 17 13.2025 17 13.4587V15.3337H10.9587C10.6137 15.3337 10.3337 15.6137 10.3337 15.9587V18.875C10.3337 19.22 10.6137 19.5 10.9587 19.5H17V21.375C17 21.6312 17.1562 21.8612 17.3937 21.9562C17.4687 21.985 17.5475 22 17.625 22C17.7925 22 17.9587 21.9325 18.0787 21.805L21.8287 17.8462C22.0575 17.605 22.0575 17.2275 21.8287 16.9875V16.9875Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.d87b2f1a1d4dd397634c291ba240f793.svg";
export { ForwardRef as ReactComponent };